<template>
  <b-overlay
    :show="modalLoading"
    blur="10px"
    opacity="0.30"
    rounded="sm"
    variant="light"
  >
    <ValidationObserver
      ref="updateMerchantForm"
      v-slot="{ handleSubmit }"
      slim
    >
      <b-form
        class="my-8"
        @submit.prevent="handleSubmit(onClickMakePickUpRequest)"
      >
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <b-form-group
              label="PickUp Request Date"
              label-for="h-name"
              label-cols-lg="3"
            >
              <ValidationProvider
                #default="{ errors }"
                name="PickUp Request Date"
                rules="required-date"
              >
                <div class="position-relative">
                  <SingleAdvancedDatePicker
                    v-model="form.date"
                    :locale-data="{ firstDay: 1, format: 'YYYY-MM-DD' }"
                    :single-date-picker="true"
                    :date-format="'YYYY-MM-DD'"
                    :min-date="config.minDate"
                    :time-picker="false"
                    :time-picker24hour="false"
                    :clear-icon="false"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <b-form-group
              label="Remark"
              label-for="h-name"
              label-cols-lg="3"
            >
              <b-form-input
                id="name"
                v-model="form.remark"
                placeholder="Enter the Remark"
                type="text"
                :state="form.remark.length < remarkMaxChar"
                :maxlength="remarkMaxChar"
              />
              <small
                class="textarea-counter-value float-right"
                :class="form.remark.length >= remarkMaxChar ? 'bg-danger' : ''"
              >
                <span class="char-count">{{ form.remark.length }}</span> / {{ remarkMaxChar }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- submit and reset -->
        <b-row>
          <b-col
            class="d-flex justify-content-end"
          >
            <div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="clearDate"
              >
                Clear
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BCol,
  BFormGroup,
  BForm,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import SingleAdvancedDatePicker from '@/components/AdvancedDateFilter/SingleAdvancedDatePicker.vue'
import moment from 'moment'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const FlagRepository = RepositoryFactory.get('flag')

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BOverlay,
    SingleAdvancedDatePicker,
  },
  mixins: [SuccessMessage, ErrorMessage],
  props: {
    waybill: {
      type: String,
      default: '',
    },
    setOpen: {
      type: Function,
      required: true,
    },
    refresh: {
      type: Function,
      required: true,
    },
    setErrors: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      open: false,
      form: {
        date: {
          startDate: null,
          endDate: null,
        },
        remark: '',
      },
      modalLoading: false,
      loading: false,
      perPage: 5,
      pageOptions: [5, 15, 25],
      totalRows: 1,
      page: 1,
      meta: {},
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'user', label: 'User', sortable: true },
        { key: 'remark', label: 'Remark', sortable: false },
        { key: 'created_date', label: 'Remark Date', sortable: false },
        { key: 'added_by', label: 'Added By', sortable: false },
      ],
      config: {
        minDate: '',
      },
      remarkMaxChar: 125,
    }
  },
  computed: {
    formattedPickupDate() {
      if (this.form.date && this.form.date.startDate) {
        return moment(this.form.date.startDate).format('YYYY-MM-DD')
      }
      return ''
    },
  },
  mounted() {
    this.getTomorrowDate()
  },
  methods: {
    async getTomorrowDate() {
      const currentDate = new Date(new Date().getTime())
      const day = currentDate.getDate()
      const month = currentDate.getMonth() + 1
      const year = currentDate.getFullYear()
      this.config.minDate = `${year}-${month}-${day}`
    },
    //
    async onClickMakePickUpRequest() {
      this.modalLoading = true
      try {
        const payload = {
          waybill_numbers: Array.isArray(this.waybill) ? this.waybill : [this.waybill],
          id: '1',
          type: 'flag_1',
          data: {
            pickup_at: this.formattedPickupDate,
            remark: this.form.remark,
          },
        }
        await FlagRepository.createFlag(payload)
        this.showSuccessMessage('Flag Made successfully')
        this.setOpen(false)
        this.refresh()
      } catch (e) {
        if (typeof this.setErrors === 'function') {
          const response = e.response?.data
          const errorList = []

          if (response?.message) {
            Object.values(response.message).forEach(entry => {
              errorList.push({
                waybill_number: entry.waybill_number,
                status: false,
                error: entry.error,
              })
            })
          } else {
            errorList.push({
              waybill_number: Array.isArray(this.waybill) ? this.waybill.join(', ') : this.waybill,
              status: false,
              error: 'Unexpected error occurred',
            })
          }

          this.setErrors(errorList)
        } else {
          this.convertAndNotifyError(e)
        }
      } finally {
        this.modalLoading = false
      }
    },
    clearDate() {
      this.form.date = {
        startDate: null,
        endDate: null,
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
